var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-wrapper"},_vm._l((_vm.projectListData),function(item,index){return _c('li',{key:item.id,staticClass:"list-item",on:{"click":function($event){_vm.onClick(item.music, item.project)}}},[_c('music-jacket',{attrs:{"imgSrc":item.jacket,"projectSrc":item.project}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30394e38","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MusicList.vue
// module id = null
// module chunks = 